<template>
	<n-card
		style="max-width: 450px; min-width: 260px"
		title="Удаление пользователя"
		:bordered="false"
		size="huge"
		role="dialog"
		aria-modal="true"
	>
		<n-form>
			<n-form-item label="Выберите пользователя">
				<n-select v-model:value="state.selected_user"
					placeholder="Выберите пользователя из выпадающего списка"
					:options="state.users" />
			</n-form-item>
			<n-space justify="space-between">
				<n-button @click="emit('modalclose')">
					Отмена
				</n-button>
				<n-button :disabled="state.selected_user === null"
					type="error"
					@click="deleteUser">
					Удалить
				</n-button>
			</n-space>
		</n-form>
	</n-card>
</template>

<script setup>

import { reactive, defineEmits, onMounted } from "vue"
import { useMessage } from "naive-ui"
import { useStore } from "vuex"

const emit = defineEmits(["modalclose"])

const message = useMessage()
const store = useStore()


const state = reactive({
	selected_user: null,
	users: []
})


const getAll = async() => {
	const response = await fetch(`${store.state.backend}/users/getall`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ token: store.state.admin.token })
	})
	if (response.ok) {
		const data = await response.json()
		const users = []
		for (let i = 0; i < data.users.length; i++) {
			users.push({
				value: data.users[i].id,
				label: `#${data.users[i].id}. ${data.users[i].login}`
			})
		}
		state.users = users
	} else {
		try {
			const data = await response.json()
			message.error(`Не удалось загрузить список пользователей. ${data.reason}`)
		} catch {
			message.error("Не удалось загрузить список пользователей")
		}
	}
}


const deleteUser = async() => {
	const response = await fetch(`${store.state.backend}/users/user`, {
		method: "DELETE",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			"token": store.state.admin.token,
			"id": state.selected_user
		})
	})
	if (response.ok) {
		message.success("Пользователя удален")
	} else {
		try {
			const data = await response.json()
			console.log(data)
			message.error(`Ошибка при попытке удалить пользователя: \n ${data.reason}`)
		} catch {
			message.error("Ошибка при попытке удалить пользователя")
		}
	}
}

onMounted(() => {
	getAll()
})

</script>